import { plus } from "../../../../SMPNum";

class Chain6 {
     constructor(service, successor) {
          this.service = service;
          this.successor = successor;
     }
     handleRequest(payload){
          //get only required param
          const  {
               gameLevel,
               currentHeroLevel,
               heroLevelAfterFarm,
               levelThatZoneBossAppear,
               goldAvailableForSupportUnlock,
               goldAvailableForSupportLevel,
               goldAvailableForSupport,
               goldAvailableForSupportSkill,
               diamondAvailableForPet,
               hitBossPerSecond,
               hitPerSecond,
               ratioSupportSkill,
               isUseSupportSkillDmg,
               isUsePetSkillDmg,
               isUsingPet,
               supportList,
               itemImpactBonus,
               marketItemWillBonus,
               timeRequireForDmgItem,
               timeRequireForHpItem,
               bossInfo,
               teamBattleInfo,
               heroHpCapSessionFromSupport,
               petList,
               isUseHeroSkillGold,
               isUseHeroSkillDmg,
               percentControlHeroGoldSkill,
               percentControlHeroDmgSkill,
               heroActiveSkillList,
               heroBossSkillList,
               isUseThunderAttackSkill,
               isUsePetAllianceSkill,
               unlockFlyingSupportCounter,
               balSupportLevelBelowBoss,
               supportCount,
               dataAutomateGameState,
          } = payload;

          //param for hero skill
          let heroSkillPayload = {
               isUseHeroSkillGold,
               isUseHeroSkillDmg,
               percentControlHeroGoldSkill,
               percentControlHeroDmgSkill,
               isUseThunderAttackSkill,
               isUsePetAllianceSkill,
          };

          //============== BUILD PAYLOAD ==================================
          let params = {
               gameLevel,
               //heroLevelAfterFarm,
               goldAvailableForSupportUnlock,
               goldAvailableForSupportLevel,
               goldAvailableForSupport,
               goldAvailableForSupportSkill,
               diamondAvailableForPet,
               hitBossPerSecond,
               hitPerSecond,
               ratioSupportSkill,
               isUseSupportSkillDmg,
               isUsePetSkillDmg,
               isUsingPet,
               supportList,
               itemImpactBonus,
               teamBattleInfo,
               petList,
               heroSkillPayload,
               unlockFlyingSupportCounter,
               balSupportLevelBelowBoss,
               supportCount
          };

          //base hero dmg with bonus
          params.heroLevelAfterFarm = currentHeroLevel;
          let heroBaseDmg = this.service.heroBaseDMGIncludeBonus(params);
          //let heroDmgSessionGainBoss = this.service.getHeroDMGSessionResultFromGainBoss(heroBaseDmg, bossInfo, teamBattleInfo);
          let heroDmgSessionFromPet = this.service.getHeroDmgSessionResultFromPets(heroBaseDmg, bossInfo, teamBattleInfo);

          //include hero skill bonus
          heroSkillPayload.heroActiveSkillList = heroActiveSkillList;
          heroSkillPayload.heroBossSkillList = heroBossSkillList;
          const heroGoldSkillBonus = this.service.getHeroSkillGoldBonus(heroSkillPayload);

          //============= COMPUTE USING PAYLOAD =====================
          //on ghost mode include element bonus from hero vs pet
          params.heroDmgSessionFromPet = heroDmgSessionFromPet;
          const killGhostPayLoad = this.service.killGhostPayLoad(params);
          killGhostPayLoad.heroDmg = heroBaseDmg;

          //on boss mode include element bonus from hero vs boss
          params.heroLevelAfterFarm = heroLevelAfterFarm;
          heroBaseDmg = this.service.heroBaseDMGIncludeBonus(params);
          let heroDmgSessionGainBoss = this.service.getHeroDMGSessionResultFromGainBoss(heroBaseDmg, bossInfo, teamBattleInfo);
          heroDmgSessionFromPet = this.service.getHeroDmgSessionResultFromPets(heroBaseDmg, bossInfo, teamBattleInfo);
          params.heroDmgSessionFromPet = heroDmgSessionFromPet;

          params.heroDmgSessionGainBoss = heroDmgSessionGainBoss;
          const killBossPayLoad = this.service.killBossPayLoad(params);
          killBossPayLoad.heroDmg = heroBaseDmg;

          //it will change to zone boss game level
          //don't forget roll back => params.gameLevel = gameLevel;
          //when use normal boss
          params.gameLevel = levelThatZoneBossAppear;
          const killZoneBossPayLoad = this.service.killZoneBossPayLoad(params);
          killZoneBossPayLoad.heroDmg = heroBaseDmg;

          const baseHeroHp = this.service.getHeroHp(heroLevelAfterFarm);
          let heroHp = baseHeroHp;

          if(!heroHpCapSessionFromSupport.bonusHp.isZero){
               heroHp = plus(heroHp, heroHpCapSessionFromSupport.bonusHp);
               //heroHp.setFromSMPNum(totalHp);
          }

          const hpItemBonus = this.service.getTotalHpItemBonus(itemImpactBonus, heroLevelAfterFarm);
          const heroHpIncludeElement = this.service.getTotalHeroHpWithItemBonus(heroHp, hpItemBonus);

          const timeHeroPossibleDieWithNormalBoss = this.service.getTimeHeroPossibleDieWithNormalBoss(heroHpIncludeElement, gameLevel);
          const timeHeroPossibleDieWithZoneBoss = this.service.getTimeHeroPossibleDieWithZoneBoss(heroHpIncludeElement, levelThatZoneBossAppear);

          const bossDps = this.service.getBossDps(gameLevel, heroHpIncludeElement);
          const zoneBossDps = this.service.getZoneBossDps(levelThatZoneBossAppear, heroHpIncludeElement);

          const generatedHeroHpPerSecond = plus(this.service.getGeneratedHeroHpPerSecond(heroHpIncludeElement), hpItemBonus);
          const expectedGeneratedHpWithBoss = this.service.getExpectedGeneratedHp(generatedHeroHpPerSecond, timeHeroPossibleDieWithNormalBoss);
          const expectedGeneratedHpWithZoneBoss = this.service.getExpectedGeneratedHp(generatedHeroHpPerSecond, timeHeroPossibleDieWithZoneBoss);

          const heroPossibleSurvive = this.service.getPossibleSurvive(heroHpIncludeElement, bossDps, generatedHeroHpPerSecond);
          const heroPossibleSurviveZoneBoss = this.service.getPossibleSurvive(heroHpIncludeElement, zoneBossDps, generatedHeroHpPerSecond);

          //for kpi game play and market place status
          let kpiBossType = "NormalBoss";
          let timeHeroPossibleDieBossOrZoneBoss = timeHeroPossibleDieWithNormalBoss;
          let timeToKillBossOrZoneBoss = killBossPayLoad.timeToKillBoss;
          let bossDpsNormalOrZone = bossDps;
          if( gameLevel === levelThatZoneBossAppear){
              timeHeroPossibleDieBossOrZoneBoss = timeHeroPossibleDieWithZoneBoss;
              timeToKillBossOrZoneBoss = killZoneBossPayLoad.timeToKillZoneBoss;
              bossDpsNormalOrZone = zoneBossDps;
              kpiBossType = "ZoneBoss";
          } else {
               params.gameLevel = gameLevel;
          }

          bossInfo.kpiBossType = kpiBossType;

          //require of game play
          const itemRequirePayload = {
               hpRequire: this.service.getHpItemRequirePayload(timeHeroPossibleDieBossOrZoneBoss, heroHpIncludeElement, bossDpsNormalOrZone, timeRequireForHpItem),
               dmgRequire: this.service.getDmgItemRequirePayload(timeToKillBossOrZoneBoss, params, timeRequireForDmgItem, kpiBossType)
          };
          if(dataAutomateGameState){
               if(dataAutomateGameState.reviveBestHero > 0){
                    itemRequirePayload.reviveHeroRequire = 1;
               }
               if(dataAutomateGameState.reviveBestSupport > 0){
                    itemRequirePayload.reviveSupportRequire = 1;
               }
          }

          //item impact in market place
          const marketWillBonusPayload = {
               hpItemBonus: this.service.getTotalHpItemBonus(marketItemWillBonus, heroLevelAfterFarm),
               dmgItemBonus: this.service.getDmgItemWillBonusOnMarketPlace(marketItemWillBonus, params),
               reviveHeroItem: marketItemWillBonus.reviveHeroItem,
               reviveSupportItem: marketItemWillBonus.reviveSupportItem
          };
         
          //prepare new payload
          let newPayload = {
               killGhostPayLoad,
               killBossPayLoad,
               killZoneBossPayLoad,
               baseHeroHp,
               heroHp,
               timeHeroPossibleDieWithNormalBoss,
               timeHeroPossibleDieWithZoneBoss,
               bossDps,
               zoneBossDps,
               generatedHeroHpPerSecond,
               expectedGeneratedHpWithBoss,
               expectedGeneratedHpWithZoneBoss,
               heroPossibleSurvive,
               heroPossibleSurviveZoneBoss,
               hpItemBonus,
               itemRequirePayload,
               marketWillBonusPayload,
               bossInfo,
               heroBaseDmg,
               // heroBaseDps,
               //heroDmgOnGhost,
               //heroDpsOnGhost,
               heroDmgSessionGainBoss,
               heroDmgSessionFromPet,
               heroSkillPayload,
               heroGoldSkillBonus,
          }

          //merge old and new to return payload
          let returnPayload = Object.assign({}, payload, newPayload);
          //forward to another successor or return
          if (this.successor) {
               return this.successor.handleRequest(returnPayload);
          } else {
               return returnPayload;
          }
     }
}
export default Chain6;